export default {
    warnings: {
        straightRow: 'Näppäimistön vierekkäiset kirjaimet ovat helppoja arvata.',
        keyPattern: 'Lyhyet näppäinsarjat ovat helppoja arvata.',
        simpleRepeat: 'Toistot kuten "aaa" ovat helppoja arvata.',
        extendedRepeat: 'Toistuvat merkkisarjat "abcabcabc" ovat helppoja arvata.',
        sequences: 'Peräkkäiset merkit kuten "abc" ovat helppoja arvata.',
        recentYears: 'Viime vuodet ovat helppoja arvata.',
        dates: 'Päivät ovat helppoja arvata.',
        topTen: 'Tämä on yksi yleisimmistä salasanoista.',
        topHundred: 'Tämä on hyvin usein käytetty salasana.',
        common: 'Tämä on hyvin yleinen salasana.',
        similarToCommon: 'Tämä on samankaltainen kuin usein käytetty salasana.',
        wordByItself: 'Sana on hyvin helppo arvata.',
        namesByThemselves: 'Yksittäiset nimet ja sukunimet ovat helppoja arvata.',
        commonNames: 'Yleisnimet ja sukunimet ovat helppoja arvata.',
        userInputs: 'Salasanassa ei tulisi olla henkilökohtaista tai sivustoon liittyvää tietoa.',
        pwned: 'Salasanasi on esiintynyt internetissä paljastetussa tietovuodossa.',
    },
    suggestions: {
        l33t: 'Vältä ennustettavissa olevia kirjainvaihtoja kuten esimerkiksi @-merkin käyttöä a:n sijasta',
        reverseWords: 'Vältä tunnettujen sanojen takaperin kirjoittamista',
        allUppercase: 'Kirjoita osa kirjaimista isolla, mutta älä kaikkia',
        capitalization: 'Käytä isoja kirjaimia muutoinkin kuin vain ensimmäisessä kirjaimessa',
        dates: 'Vältä sinuun liitettävissä olevia päivämääriä ja vuosilukuja',
        recentYears: 'Vältä lähivuosien käyttöä',
        associatedYears: 'Vältä sinuun liitettävissä olevien vuosilukujen käyttöä',
        sequences: 'Vältä tunnettuja merkkisarjoja',
        repeated: 'Vältä sanojen ja merkkien toistamista',
        longerKeyboardPattern: 'Käytä salasanassa pidempiä näppäinsarjoja ja vaihda kirjoitussuuntaa useasti',
        anotherWord: 'Käytä salasanassa lisää vähemmän tunnettuja sanoja',
        useWords: 'Voit käyttää salasanassa useampia sanoja, mutta vältä kuitenkin tunnettuja lauseita',
        noNeed: 'Voit luoda vahvan salasanan myös käyttämättä symboleja, numeroita tai isoja kirjaimia',
        pwned: 'Jos käytät tätä salasanaa muualla, sinun kannattaa vaihtaa se pian',
    },
    timeEstimation: {
        ltSecond: 'alle sekunti',
        second: '{base} sekunti',
        seconds: '{base} sekuntia',
        minute: '{base} minuutti',
        minutes: '{base} minuuttia',
        hour: '{base} tunti',
        hours: '{base} tuntia',
        day: '{base} päivä',
        days: '{base} päivää',
        month: '{base} kuukausi',
        months: '{base} kuukautta',
        year: '{base} vuosi',
        years: '{base} vuotta',
        centuries: 'vuosikymmeniä',
    },
};
//# sourceMappingURL=translations.js.map